module.exports = __webpack_public_path__ + "img/图片6.bb25e86c.png";